import { useState } from "react";
import { AUFGABE, useDialog } from "../../kern/dialog";
import { Bestaetigung } from "../../kern/ui/Bestaetigung";
import { useHinweis } from "../../kern/ui/Hinweise";
import type { Aufgabe } from "./logik";
import { loeschFrage } from "./listenlogik";
import type { useSchnellaktionen } from "./aktionen";

type Schnell = ReturnType<typeof useSchnellaktionen>;

/** Löschen (weich) mit Rückfrage und Rückgängig (AUFGABEN-LISTE.md, Abschnitt 4). Ist der Dialog dieser Aufgabe offen, schließt er,
 *  bei einer Unteraufgabe geht er zurück zur Aufgabe. `sofort` ohne Rückfrage: Papierkorb bei Unteraufgaben im Dialog. */
export function useLoeschen(sa: Schnell) {
  const { zeigen } = useHinweis();
  const dialog = useDialog(AUFGABE);
  const [frage, setFrage] = useState<Aufgabe | null>(null);

  function ausfuehren(a: Aufgabe) {
    sa.akt.archivieren.mutate(a.id, {
      onSuccess: () => {
        zeigen(`„${a.titel}“ gelöscht.`, { rueckgaengig: () => sa.akt.wiederherstellen.mutate(a.id, { onError: sa.fehler }) });
        if (dialog.offen && dialog.wert === a.id) {
          if (a.eltern_id) dialog.wechseln(AUFGABE, a.eltern_id);
          else dialog.schliessen();
        }
      },
      onError: sa.fehler,
    });
  }

  function wiederherstellen(a: Aufgabe) {
    sa.akt.wiederherstellen.mutate(a.id, { onSuccess: () => zeigen(`„${a.titel}“ wiederhergestellt.`), onError: sa.fehler });
  }

  const f = frage ? loeschFrage(frage, frage.unteraufgaben_gesamt, frage.kommentare) : null;
  const rueckfrage = (
    <Bestaetigung
      offen={!!frage}
      titel={f?.titel ?? "Aufgabe löschen?"}
      bestaetigen="Löschen"
      gefaehrlich
      onBestaetigen={() => {
        const a = frage;
        setFrage(null);
        if (a) ausfuehren(a);
      }}
      onAbbrechen={() => setFrage(null)}
    >
      <p>{f?.text}</p>
    </Bestaetigung>
  );

  return {
    loeschen: (a: Aufgabe, sofort = false) => (sofort ? ausfuehren(a) : setFrage(a)),
    wiederherstellen,
    rueckfrage,
  };
}
